import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import infiniteScroll from 'vue-infinite-scroll'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/style/quill.core.css'
import './assets/style/quill.snow.css'
import './assets/style/common.css'
import * as echarts from "echarts";
import VueAwesomeSwiper from 'vue-awesome-swiper'
import "swiper/swiper.scss";
import "swiper/css/swiper.css"
import 'babel-polyfill'
import config from '@/utils/config'
import { statisticalData,getUserInFo } from '@/utils/api'
import dayjs from 'dayjs'
Vue.prototype.$dayjs = dayjs
Vue.prototype.$config = config
Vue.prototype.$echarts = echarts
import Footer from './components/Footer.vue'
import tabBanner from './components/tabBanner'
Vue.component('Footer',Footer)
Vue.component('tabBanner',tabBanner)
Vue.use(ElementUI)
Vue.use(infiniteScroll)
Vue.use(VueAwesomeSwiper)
Vue.config.productionTip = false
Vue.filter('filterNum',function(value){
  return value>1000000?'100w+':value
})
// 统计访问量
const visits = sessionStorage.getItem('visits')
if (Number(visits)!=1) {
  statisticalData({
    organizeId: config.organizeId,
    category: '门户访问'
  }).then(res => {
    if (res.code === 200) {
      sessionStorage.setItem('visits',1)
      
    }
  })
}
document.querySelector("meta[name='viewport']")["content"] = ""
// 根据token获取个人信息
if(store.state.token){
  getUserInFo({
    id:store.state.token
  }).then(res=>{
    if(res.code==401){
      store.commit('set_token',"") 
    }else{
      store.commit('set_user_info',res.data)
    }
    
  })
}


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
